/* eslint-disable import/extensions */
import { OptionType } from '@oberoninternal/travelbase-ds/components/form/SelectInput';
import countryCodes from './countryCodes.json';

const countryOptions = Object.entries(countryCodes).map(([key, value]): OptionType => ({ label: value, value: key }));

export const nlCountryOption = countryOptions.find(option => option.value === 'NL')!; // it exists, trust me

export default countryOptions;
